import getElementSelectors from '../shares/lib/getElementSelectors';

const addDropdownToggleEvent = (): void => {
  const { dropdownToggle, dropdown, dropDownOverlay } = getElementSelectors();

  if (dropdownToggle) {
    dropdownToggle.addEventListener('click', (e: MouseEvent) => {
      dropdown?.classList.toggle('open');
      dropDownOverlay?.classList.toggle('open');
      e.stopPropagation();
    });
  }
};

export default addDropdownToggleEvent;
